import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";

@Injectable({
 providedIn: "root",
})
export class AppContextService {
 context = {
  wcolumn: 3,
  ncolumn : 2,
  wfull: 12,
  minMonthYear: "2021-07-01",
  maxMonthYear: "2026-07-01",
  type2sign: "Maklervollmacht",
  type2sign2: "Vollmacht",
  roleUser: "Makler",
  user: {
   fields: {
    vollmachten: [],
    stammdaten_praxis: {},
    erfassung_pverm: {},
    honorar_beratung: {},
    honorar_marketing: {},
    honorar_gruendung: {},
    praxisvermittlungkauf: {},
    praxisvermittlungverkauf: {},
   },
   anrede: null,
   anzahl_erinnerungen: null,
   beratung_weitere_produkte: null,
   buro_id: null,
   c_o: null,
   created_at: null,
   datenweitergabe_an_personen: null,

   einwilligung_personalvermittlung: null,
   einwilligung_praxisvermittlungverkauf: null,
   einwilligung_praxisvermittlungkauf: null,

   einwilligung_paragraph365: null,
   einwilligung_verschwiegenheitspflicht_kauf: null,
   einwilligung_widerruf: null,

   einwilligung_honorarmarketing: null,
   einwilligung_honorarberatung: null,
   einwilligung_honorargruendung: null,

   einwilligung_vollmacht: null,
   einwilligung_bestandsaufnahme: null,
   einwilligung_datenschutzerklaerung: null,
   einwilligung_erstinformation: null,
   einwilligung_kommunikation: null,
   einwilligung_versicherungsmaklervertrag: null,
   email: null,
   geburtsdatum: null,
   gesperrt: null,
   id: null,
   key: null,
   key_valid_until: null,
   kommunikation_brief: null,
   kommunikation_fax: null,
   kommunikation_telefon: null,
   kommunikation_email: null,
   kommunikation_whatsapp: null,
   kundennummer: null,
   name: null,
   land: null,
   ort: null,
   plz: null,
   strasse: null,
   titel: null,
   ts_finished: null,
   ts_lastlogin: null,
   ts_letzte_erinnerung: null,
   ts_letzter_export: null,

   unterschrift_datenschutzerklaerung: null,
   unterschrift_erstinformation: null,
   unterschrift_kommunikation: null,
   unterschrift_versicherungsmaklervertrag: null,
   unterschrift_versicherungsmaklervertrag_vp: null,
   unterschrift_vollmacht: null,

   updated_at: null,
   user_id: null,
   vertragsbestand: null,
   vertragsgegenstand_beruflich: null,
   vertragsgegenstand_privat: null,
   vorname: null,
  },
  isPlatformDesktop: false,
  isPlatformMobile: false,
  isPlatformTablet: false,
  isLoggedIn: false,
  isStammdatenVisited: false,
  isStammdatenPraxisVisited: false,

  isErfassungPVermVisited: false,
  ispraxisvermittlungkaufVisited: false,
  ispraxisvermittlungverkaufVisited: false,
  isHonorar_beratungVisited: false,
  isHonorar_marketingVisited: false,
  isHonorar_gruendungVisited: false,

  isUmfangVisited: false,
  isBestandsaufnahmeVisited: false,
  isDatenschutzVisited: false,
  isZusammenfassungVisited: false,
  isEinwilligungVisited: false,
  isUnterschriftVisited: false,
  privatDisplayString: "",
  berufDisplayString: "",
  kommunikationDisplayString: "",
  privat: {
   priv_berufsunfaehigkeitsversicherung: {
    label: "Berufsunfähigkeitsversicherung",
    value: false,
   },
   priv_altersvorsorge: {
    label: "Altersvorsorge",
    value: false,
   },
   priv_risikolebensversicherung: {
    label: "Risikolebensversicherung",
    value: false,
   },
   priv_schwere_krankheiten_versicherung: {
    label: "Schwere Krankheiten Versicherung",
    value: false,
   },
   priv_krankenversicherung: {
    label: "Krankenversicherung",
    value: false,
   },
   priv_pflegeversicherung: {
    label: "Pflegeversicherung",
    value: false,
   },
   priv_krankentagegeld: {
    label: "Krankentagegeld",
    value: false,
   },
   priv_unfallversicherung: {
    label: "Unfallversicherung",
    value: false,
   },
   priv_private_haftpflichtrisiken: {
    label: "Private Haftpflichtrisiken",
    value: false,
   },
   priv_gebaeudeversicherung: {
    label: "Gebäudeversicherung",
    value: false,
   },
   priv_hausratversicherung: {
    label: "Hausratversicherung",
    value: false,
   },
   priv_glasversicherung: {
    label: "Glasversicherung",
    value: false,
   },
   priv_kfz_versicherung: {
    label: "KFZ-Versicherung",
    value: false,
   },
   priv_rechtsschutzversicherung: {
    label: "Rechtsschutzversicherung",
    value: false,
   },
   priv_reiseversicherungen: {
    label: "Reiseversicherungen",
    value: false,
   },
  },
  beruf: {
   beruf_berufshaftpflichtversicherung: {
    label: "Berufshaftpflichtversicherung",
    value: false,
   },
   beruf_inventarversicherung: {
    label: "Inventarversicherung",
    value: false,
   },
   beruf_elektronikversicherung_cyberrisk: {
    label: "Elektronikversicherung / Cyberrisk",
    value: false,
   },
   beruf_betriebsunterbrechung: {
    label: "Betriebsunterbrechung",
    value: false,
   },
   beruf_praxisausfallversicherung: {
    label: "Praxisausfallversicherung",
    value: false,
   },
   beruf_rechtsschutzversicherung: {
    label: "Rechtsschutzversicherung",
    value: false,
   },
   beruf_kfz_versicherung: {
    label: "KFZ-Versicherung",
    value: false,
   },
   beruf_transportversicherung: {
    label: "Transportversicherung",
    value: false,
   },
   beruf_kuehlgutversicherung: {
    label: "Kühlgutversicherung",
    value: false,
   },
   beruf_betriebliche_altersversorgung: {
    label: "Betriebliche Altersversorgung",
    value: false,
   },
   beruf_betriebliche_krankenversicherung: {
    label: "Betriebliche Krankenversicherung",
    value: false,
   },
  },
 };

 cfgBottomDrawer = {
  start: {
   show: false,
   index: 0,
  },
  stammdaten: {
   show: false,
   index: 0,
  },
  stammdaten_praxis: {
   show: false,
   index: 0,
  },

  erfassung_pverm: {
   show: false,
   index: 0,
  },
  praxisvermittlungkauf: {
   show: false,
   index: 0,
  },
  praxisvermittlungverkauf: {
   show: false,
   index: 0,
  },
  honorar_beratung: {
   show: false,
   index: 0,
  },
  honorar_marketing: {
   show: false,
   index: 0,
  },
  honorar_gruendung: {
   show: false,
   index: 0,
  },

  umfang: {
   show: false,
   index: 0,
  },
  bestandsaufnahme: {
   show: false,
   index: 0,
  },
  datenschutz: {
   show: false,
   index: 0,
  },
  zusammenfassung: {
   show: false,
   index: 0,
  },
  einwilligung: {
   show: false,
   index: 0,
  },
  unterschrift: {
   show: false,
   index: 0,
  },
 };

 minOne(base: object, sonstiges: object) {
  if (base) {
   for (let [key, value] of Object.entries(base)) {
    if (value["value"]) return true;
   }
   if (sonstiges) return true;
  }

  return false;
 }

 isValid(base: object, validationArray: object[]) {
  if (base) {
    //console.log("Validating...");
   for (let entity of validationArray) {
    //console.log(entity);
    var value = base[entity["name"]];
    switch (entity["type"]) {
     case "minOne": {
      if (!this.minOne(value, base[entity["sonstiges"]])) return false;
      break;
     }
     case "single": {
      if (!value) return false;
      break;
     }
     case "one": {
      var value1 = base[entity["name1"]];
      if (!value && !value1) return false;
     }

     case "dependent": {
      var compareDep = base[entity["dep_name"]];
      switch (entity["operation"]) {
       case "equal": {
        if (entity["cmp_value"] == compareDep) if (!value) return false;
        break;
       }
       case "notset": {
        if (!base[entity["dep_name"]]) if (!value) return false;
        break;
       }
      }
      break;
     }
    }
   }
   return true;
  }
  return false;
 }

 initBottomDrawer() {
  const vollmachtTypen = this.context.user.fields.vollmachten;
  var pages = Array("start", "zusammenfassung", "einwilligung", "unterschrift");

  if (vollmachtTypen.indexOf("maklervollmacht") > -1) pages = pages.concat(["stammdaten", "umfang", "bestandsaufnahme", "datenschutz"]);
  if (vollmachtTypen.indexOf("personalvermittlung") > -1) {
    this.context.type2sign = "Vertragsunterlagen";
    this.context.type2sign2 = "Vereinbarung";
    this.context.roleUser = "Berater";
    pages = pages.concat(["stammdaten_praxis", "erfassung_pverm", "datenschutz"]);
  }
  if (vollmachtTypen.indexOf("praxisvermittlungverkauf") > -1) {
   this.context.type2sign = "Vertragsunterlagen";
   this.context.type2sign2 = "Vereinbarung";
   this.context.roleUser = "Berater";
   pages = pages.concat(["stammdaten_praxis", "praxisvermittlungverkauf", "datenschutz"]);
  }
  if (vollmachtTypen.indexOf("praxisvermittlungkauf") > -1) {
   this.context.type2sign = "Vertragsunterlagen";
   this.context.type2sign2 = "Vereinbarung";
   this.context.roleUser = "Berater";
   pages = pages.concat(["stammdaten", "praxisvermittlungkauf", "datenschutz"]);
  }
  if (vollmachtTypen.indexOf("honorarmarketing") > -1) {
   this.context.type2sign = "Vertragsunterlagen";
   this.context.type2sign2 = "Vereinbarung";
   this.context.roleUser = "Berater";
   pages = pages.concat(["stammdaten", "honorar_marketing", "datenschutz"]);
  }
  if (vollmachtTypen.indexOf("honorarberatung") > -1) {
   this.context.type2sign = "Vertragsunterlagen";
   this.context.type2sign2 = "Vereinbarung";
   this.context.roleUser = "Berater";
   pages = pages.concat(["stammdaten", "honorar_beratung", "datenschutz"]);
  }
  if (vollmachtTypen.indexOf("honorargruendung") > -1) {
   this.context.type2sign = "Vertragsunterlagen";
   this.context.type2sign2 = "Vereinbarung";
   this.context.roleUser = "Berater";
   pages = pages.concat(["stammdaten", "honorar_gruendung", "datenschutz"]);
  }
  var index = 0;
  for (let key in this.cfgBottomDrawer) {
   if (pages.indexOf(key) > -1) {
    this.cfgBottomDrawer[key].show = true;
    this.cfgBottomDrawer[key].index = index;
    index++;
   }
  }
 }

 getNextPage(actual: string) {
  console.log("actual: " + actual);
  var found = false;
  for (let key in this.cfgBottomDrawer) {
   if (key == actual) {
    found = true;
   } else {
    if (found && this.cfgBottomDrawer[key].show) {
     console.log("next: " + key);
     return key;
    }
   }
  }
  console.log("next: null");
  return null;
 }

 constructor(public platform: Platform) {
  console.log(this.platform);
  this.context.isPlatformDesktop = this.platform.is("desktop");
  this.context.isPlatformMobile = this.platform.is("mobileweb") || this.platform.is("mobile");
  this.context.isPlatformTablet = this.platform.is("tablet");

  if (this.platform.is("desktop")) {
   this.context.wcolumn = 3;
   this.context.ncolumn = 1.7;
  }
  if (this.platform.is("mobileweb") || this.platform.is("mobile")) {
   this.context.wcolumn = 12;
   this.context.ncolumn = 12;
  }
  if (this.platform.is("tablet")) {
   this.context.wcolumn = 4;
   this.context.ncolumn = 4;
  }
 }
}
